import React from "react";
import { Routes } from "react-router-dom";

import ClientHomeRoutes from "../components/client-home/routes/client-home.routes";
import ClientListingRoutes from "../components/client-listing/routes/client-listing.routes";
import ClientSearchFormRoutes from "../components/client-searchForm/routes/client-searchForm.routes";
import ClientTicketRoutes from "../components/client-tickets/routes/client-ticket.routes";
// import ClientChatRoutes from "../components/client-chat/routes/client-chat.routes";
import ClientAuthRoutes from "../components/auth-client/routes/client.auth.routes";
import ClientChatListRoutes from "../components/client-chatList/routes/client-chatList.routes";
import ClientUserListRoutes from "../components/client-userList/routes/client-userList.routes";
import ClientServicesRoutes from "../components/client-services/routes/client-services.routes";
import ClinetServiceDetailsRoutes from "../components/client-service-details/routes/client-service-details.routes";
import ClientPanelRoutes from "../components/client-panel/routes/client_panel.routes";
import ClientAppointmentSuccess from "../components/book-appointment/routes/client-appointment.routes";
import ClientAbout from "../components/about/routes/client.about.routes";
import ClientCommunity from "../components/community/routes/client.community.routes";

const ClientRoutes = () => {
  return (
    <Routes>
      {ClientHomeRoutes()}
      {ClientListingRoutes()}
      {ClientSearchFormRoutes()}
      {ClientTicketRoutes()}
      {/* {ClientChatRoutes()} */}
      {ClientAuthRoutes()}
      {ClientChatListRoutes()}
      {ClientUserListRoutes()}
      {ClientServicesRoutes()}
      {ClinetServiceDetailsRoutes()}
      {ClientPanelRoutes()}
      {ClientAppointmentSuccess()}
      {ClientAbout()}
      {ClientCommunity()}
    </Routes>
  );
};

export default ClientRoutes;